import React from "react";

const NotificationIcon = (props:any) => {
  return (
    <div>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.8">
          <path
            d="M11.4417 17.9998C11.2952 18.2524 11.0849 18.462 10.8319 18.6078C10.5788 18.7535 10.292 18.8302 10 18.8302C9.70802 18.8302 9.42116 18.7535 9.16814 18.6078C8.91513 18.462 8.70484 18.2524 8.55833 17.9998M15 7.1665C15 5.84042 14.4732 4.56865 13.5355 3.63097C12.5979 2.69329 11.3261 2.1665 10 2.1665C8.67392 2.1665 7.40215 2.69329 6.46447 3.63097C5.52678 4.56865 5 5.84042 5 7.1665C5 12.9998 2.5 14.6665 2.5 14.6665H17.5C17.5 14.6665 15 12.9998 15 7.1665Z"
            stroke={props?.color ?? "black"}
            stroke-width="0.833333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </div>
  );
};

export default NotificationIcon;
